import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NODE_ENV } from 'runtimeEnvVars';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    if (NODE_ENV !== 'production') {
      window.console.error(error);
    }
    this.props.dispatchErrorMessage();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            textAlign: 'center',
            padding: '24px',
          }}
        >
          <h1>Something went wrong</h1>
          <p>
            Try reloading the page. If the problem continues, contact support.
          </p>
          <button type="button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }
    return <>{this.props.children}</>;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  dispatchErrorMessage: PropTypes.func.isRequired,
};

export default ErrorBoundary;
